import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useState, useEffect, Children, isValidElement, cloneElement } from 'react';
import { Button } from '../Button.js';
import { jsx } from 'react/jsx-runtime';
import { Tooltip } from '../../Tooltip/Tooltip.js';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.js';

var _excluded = ["children", "multiple", "selectedIndexes", "onChange"];
var ToggleButton = /*#__PURE__*/forwardRef(function ToggleButton(_ref, ref) {
  var children = _ref.children,
    multiple = _ref.multiple,
    selectedIndexes = _ref.selectedIndexes,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(selectedIndexes || []),
    _useState2 = _slicedToArray(_useState, 2),
    pickedIndexes = _useState2[0],
    setPickedIndexes = _useState2[1];
  useEffect(function () {
    if (Array.isArray(selectedIndexes)) {
      setPickedIndexes(selectedIndexes);
    }
  }, [selectedIndexes]);
  function updateProps(child, isSelected, index) {
    var childElement = child;
    if ( /*#__PURE__*/isValidElement(child) && child.type === Button) {
      var buttonProps = {
        'aria-pressed': isSelected ? true : undefined,
        variant: isSelected ? 'contained' : 'outlined',
        onClick: function onClick(e) {
          var _childElement$props, _childElement$props$o;
          (_childElement$props = childElement.props) === null || _childElement$props === void 0 ? void 0 : (_childElement$props$o = _childElement$props.onClick) === null || _childElement$props$o === void 0 ? void 0 : _childElement$props$o.call(_childElement$props, e);
          var updatedSelection = [index];
          if (multiple) {
            updatedSelection = pickedIndexes.includes(index) ? pickedIndexes.filter(function (i) {
              return i !== index;
            }) : [].concat(_toConsumableArray(pickedIndexes), [index]);
          }
          setPickedIndexes(updatedSelection);
          if (onChange) {
            onChange(updatedSelection);
          }
        }
      };
      return /*#__PURE__*/cloneElement(child, buttonProps);
    }
  }
  var updatedChildren = Children.map(children, function (child, index) {
    var isSelected = pickedIndexes.includes(index);
    var childElement = child;
    if ( /*#__PURE__*/isValidElement(child) && child.type === Tooltip) {
      var updatedGrandChildren = Children.map(childElement.props.children, function (grandChild) {
        return updateProps(grandChild, isSelected, index);
      });
      return /*#__PURE__*/cloneElement(childElement, null, updatedGrandChildren[0]);
    } else {
      return updateProps(childElement, isSelected, index);
    }
  });
  return /*#__PURE__*/jsx(ButtonGroup, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: updatedChildren
  }));
});

export { ToggleButton };
